export const PROPERTY_SIGNUP_MESSAGE =
  "Please complete your property details to continue."

/** Session keys used by SignupForm when login/guard forces property setup. */
export function markPropertySignupRequired() {
  try {
    sessionStorage.setItem("signup_current_step", "2")
    sessionStorage.setItem("signup_current_page", "signup")
    sessionStorage.setItem("signup_redirect_message", PROPERTY_SIGNUP_MESSAGE)
  } catch {
    /* ignore */
  }
}

export function isMissingOrganizationError(error) {
  const message =
    typeof error === "string"
      ? error
      : error?.message ?? error?.payload ?? ""
  return String(message).toLowerCase().includes("organization is required")
}

export function userNeedsPropertySetup(clients, clientsStatus, clientsError) {
  if (!Array.isArray(clients) || clients.length > 0) return false
  if (clientsStatus === "succeeded") return true
  return clientsStatus === "failed" && isMissingOrganizationError(clientsError)
}
